module.exports = __webpack_public_path__ + "static/img/baidu.e66d76a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/baidu.png
// module id = 3xvS
// module chunks = 0